import createPerSliceIdSelector from '../helpers/createPerSliceIdSelector';
import get from '../helpers/get';
import { getSliceContent } from './content';

export const getSliceIsEdgeToEdge = createPerSliceIdSelector(
  getSliceContent,
  content => get(content, ['edge_to_edge']) !== 'No',
);

export const getSliceNavItems = createPerSliceIdSelector(
  getSliceContent,
  content => {
    const result = [];
    const maybePush = item => {
      if (item && item.url) {
        result.push(item);
      }
    };
    maybePush(get(content, ['nav_item_1']));
    maybePush(get(content, ['nav_item_2']));
    maybePush(get(content, ['nav_item_3']));
    return result;
  },
);

export const getSliceHeaderAspect = createPerSliceIdSelector(
  getSliceContent,
  content => (get(content, ['items', 0, 'hero_image', 'aspect'])
    || get(content, ['items', 0, 'hero_video', 'aspect'])),
);

export const getSliceMobileHeaderAspect = createPerSliceIdSelector(
  getSliceContent,
  content => (get(content, ['items', 0, 'hero_image', 'alternatives', 'Mobile', 'aspect'])
    || get(content, ['items', 0, 'hero_video', 'alternatives', 'Mobile', 'aspect'])),
);
